import React, {Component} from 'react';
import { Link } from 'react-router-dom';

import '../../scss/player.css'
// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import pic1 from "../../images/about/pic-1.jpg";
import icon1 from "../../images/icon/icon1.png";
import icon2 from "../../images/icon/icon2.png";
import icon3 from "../../images/icon/icon3.png";
import animateWave from "../../images/shap/wave-blue.png";
import animate2 from "../../images/shap/circle-dots.png";
import animateRotate from "../../images/shap/plus-blue.png";
import imgPin from "../../marker-icons/mapbox-marker-icon-20px-green.png";
  
import ReactMapGL,{Marker} from 'react-map-gl';

 
class ContactUs extends Component{
		
 	render(

		
	){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner banner-lg contact-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Contacto</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Contacto</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={animateWave} alt=""/>
							<img className="pt-img2 animate2" src={animate2} alt=""/>
							<img className="pt-img3 animate-rotate" src={animateRotate} alt=""/>
						</div>
					</div>
					
					<section className="">
						<div className="container">
							<div className="contact-wraper">
								<div className="row">
 
									<div className="col-lg-12 mb-30">
										<div className="contact-info ovpr-dark" style={{backgroundImage: "url("+pic1+")"}}>
											<div className="info-inner">
												<h4 className="title mb-30">Contacte con nosotros para cualquier información</h4>
												<div className="icon-box">
													<h6 className="title"><i className="ti-map-alt"></i>Ubicación</h6>		
													<ReactMapGL
													 onViewportChange={nextViewport =>
														this.setState({ viewport: { ...nextViewport, width: "100%" } })
													  }
														initialViewState={{
															longitude:-102.29959196746864,
															latitude:21.86368612904328,
															zoom: 15
														}}
														style={{ height: '35vh'}}
														mapboxAccessToken="pk.eyJ1IjoiaXNhYWNocSIsImEiOiJjajFtZm5zYWUwMDc2MzJtaGk1dWlhd205In0.az-G6ASH8SGpA3Cj970srQ"
														mapStyle="mapbox://styles/mapbox/streets-v9"
													>
														 
													<Marker  
													longitude={-102.29990663704739} 
													latitude={21.863229820648446} 
													anchor="bottom"
													captureClick={false}
													draggable={false}
													offsetTop={-30}
													offsetLeft={-15}
													>
 
													 
														<img src={imgPin} alt="Republica de Brasil 712"/>
													  </Marker>
													</ReactMapGL>
														
										
 													<a className="text-white" target="_blank" rel="noreferrer" href="https://goo.gl/maps/W4hoPAVBjZkY65df8">Republica de Brasil No 712, Colonia Las Américas, C.P. 20230 Aguascalientes, Ags. Mexico</a>
												</div>
												
												<div className="icon-box">
													<h6 className="title"><i className="ti-id-badge"></i>Email &amp; Teléfono</h6>
													<a className="colorAlt" target="_blank" rel="noreferrer" href="mailto:dr.alvarezdelcastillo@gmail.com">dr.alvarezdelcastillo@gmail.com</a>	
													<p className="text-white" ></p>
													<a className="text-white" target="_blank" rel="noreferrer" href="tel:4491647579">449 164 7579 (24 Hrs - 365 dias)</a>			
												</div>
												<div className="icon-box">
													<h6 className="title"><i className="ti-world"></i>Encuéntranos en</h6>	
													<ul className="social-media">
														<li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/Gastrocirugiaags/"><i className="fab fa-facebook-f"></i></a></li>
														<li><a target="_blank" rel="noreferrer" href="https://www.doctoralia.com.mx/eduardo-alvarez-del-castillo-sanchez/cirujano-general/aguascalientes"><i className="fas fa-briefcase-medical"></i></a></li>
														<li><a className='liAuto'target="_blank" rel="noreferrer" href="https://www.doctoralia.com.mx/eduardo-alvarez-del-castillo-sanchez/cirujano-general/aguascalientes"> Agendar Cita </a></li>
														<li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/eduardo-javier-%C3%A1lvarez-del-castillo-sanchez-4a5656169/" ><i className="fab fa-linkedin-in"></i></a></li>
														<li><a target="_blank" rel="noreferrer" href="https://agsmedico.com/cirugia-general/alvarezdelcastillo"><i className="fas fa-user-md"></i></a></li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature4">
										<div className="icon-md feature-icon">
											<img src={icon1} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Emergencias</h5>
											<a target="_blank" rel="noreferrer" href="tel:4491647579">449 164 7579 (24 Hrs - 365 dias)</a>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature3">
										<div className="icon-md feature-icon">
											<img src={icon3} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Email</h5>
											<a target="_blank" rel="noreferrer" href="mailto:dr.alvarezdelcastillo@gmail.com">dr.alvarezdelcastillo @ gmail.com</a>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature2">
										<div className="icon-md feature-icon">
											<img src={icon2} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Dirección</h5>
											<a target="_blank" rel="noreferrer" href="https://goo.gl/maps/W4hoPAVBjZkY65df8">Republica de Brasil No 712, Colonia Las Américas, C.P. 20230 Aguascalientes, Ags.</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ContactUs;
